import Slider from '../components/slider';

export default class QuestionsForm {

  constructor(container) {
    this.container = container;
    this.sliderContainer = this.container.find('.o-slider')[0];
    this.questionContainer = this.container.find('.c-questions-form__question')[0];
    this.nextButton = this.container.find('.c-questions-form__next-button')[0];
    this.prevButton = this.container.find('.c-questions-form__prev-button')[0];
    this.submitButton = this.container.find('.c-questions-form__submit')[0];
    this.restartButton = this.container.find('.c-questions-form__restart-button')[0];
    this.retryButton = this.container.find('.c-questions-form__retry-button')[0];
    this.questionField = this.container.find('.c-questions-form__field--question input')[0];
    this.nameField = this.container.find('.c-questions-form__field--name input')[0];
    this.emailField = this.container.find('.c-questions-form__field--email input')[0];
    this.termsField = this.container.find('.c-questions-form__field--terms input')[0];
    this.successMessage = this.container.find('.c-questions-form__message--success')[0];
    this.errorMessage = this.container.find('.c-questions-form__message--error')[0];

    this.questionErrorText = 'Ihre Frage ist zu kurz. Bitte geben Sie mindestens 20 Zeichen ein.';
    this.emailErrorText = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    this.nameErrorText = 'Bitte geben Sie Ihren vollständigen Namen an.';

    this.widgetId = null;

    this.init();
  }

  init() {
    var that = this;

    if (!this.sliderContainer) {
      return;
    }

    this.slider = new Slider(this.sliderContainer, {
      slidesPerView: 1,
      allowTouchMove: false,
    });

    $(this.nextButton).click(function(){
      const question = $(that.questionField).val();
      $(that.questionField).parent().children('.c-questions-form__field__error').remove();

      if (question.length > 19) {
        $(that.questionField).removeClass('o-input--text--error');
        $(that.questionContainer).html(question);
        that.slider.next();
      } else {
        var errorEl = $('<div>').addClass('c-questions-form__field__error');
        errorEl.html(that.questionErrorText);
        $(that.questionField).parent().append(errorEl);
        $(that.questionField).addClass('o-input--text--error');
      }
    });

    $(this.prevButton).click(function(){
      that.slider.prev();
    });

    $(this.restartButton).click(function(){
      that.resetAllFields();
      that.slider.slideTo(0);
    });

    $(this.retryButton).click(function(){
      that.slider.slideTo(1);
    });

    window.grecaptcha.ready(function(){
      $(that.submitButton).click(function(){
        if (that.validate()) {
          window.grecaptcha.execute(that.widgetId);
        }
      });

      window.grecaptcha.context = that;
      that.widgetId =  window.grecaptcha.render('c-questions-form__recaptcha', {
        'sitekey' : '6LcKd8QUAAAAAHWzoiOu0Np_8zgax01m7r6uvY2j',
        'callback' : that.sendQuestion,
        'size' : 'invisible',
      });
    });
  }

  validate() {
    var that = this;

    const testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
    const email = $(that.emailField).val();
    const name = $(that.nameField).val();
    const termsAccepted = that.termsField.checked;
    var passes = true;

    $(that.emailField).parent().children('.c-questions-form__field__error').remove();
    $(that.nameField).parent().children('.c-questions-form__field__error').remove();

    if (testEmail.test(email) == false) {
      var emailErrorEl = $('<div>').addClass('c-questions-form__field__error');
      emailErrorEl.html(that.emailErrorText);
      $(that.emailField).parent().append(emailErrorEl);
      $(that.emailField).addClass('o-input--text--error');
      passes = false;
    } else {
      $(that.emailField).removeClass('o-input--text--error');
    }

    if (name.length < 5) {
      var nameErrorEl = $('<div>').addClass('c-questions-form__field__error');
      nameErrorEl.html(that.nameErrorText);
      $(that.nameField).parent().append(nameErrorEl);
      $(that.nameField).addClass('o-input--text--error');
      passes = false;
    } else {
      $(that.nameField).removeClass('o-input--text--error');
    }

    if (termsAccepted == false) {
      $(that.termsField).addClass('o-input--checkbox--error');
      passes = false;
    } else {
      $(that.termsField).removeClass('o-input--checkbox--error');
    }

    return passes;
  }

  sendQuestion(token) {
    let that = window.grecaptcha.context;

    var question = $(that.questionField).val();
    var email = $(that.emailField).val();
    var name = $(that.nameField).val();
    var termsAccepted = that.termsField.checked;

    var sendData = {
        'dataType': 'json',
        'action': 'send_question',
        'termsAccepted': termsAccepted,
        'question': question,
        'email': email,
        'name': name,
        'token' : token,
    };

    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: function (response) {
        const result = JSON.parse(response);

        if (result['success'] === 1) {
          that.showSuccess();
        } else {
          that.showError();
        }

        window.grecaptcha.reset(that.widgetId);
      },
      error: function () {
        that.showError();
        window.grecaptcha.reset(that.widgetId);
      },
    });
  }

  showSuccess() {
    this.slider.slideTo(2);
    $(this.successMessage).show(0);
    $(this.errorMessage).hide(0);
  }

  showError() {
    this.slider.slideTo(2);
    $(this.successMessage).hide(0);
    $(this.errorMessage).show(0);
  }

  resetAllFields() {
    $(this.questionField).val(null);
    $(this.questionContainer).html('');
    this.termsField.checked = false;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/questions-form.js